/** The NavBar trailing action (`+` on Leads / Calendar / Bookings, "More" on a booking): the screen registers it; the Shell renders it. */
import { createContext, useContext, useEffect, useRef, type ReactNode } from "react";

export type NavAction = { label: string; icon: ReactNode; onClick: () => void };
export type NavActionCtx = { set: (action: NavAction | null) => void };
export const NavActionContext = createContext<NavActionCtx>({ set: () => undefined });

/** Call from a screen: while mounted, the Shell shows `action` in the NavBar. */
export function useNavAction(action: NavAction | null): void {
  const { set } = useContext(NavActionContext);
  const ref = useRef(action);
  ref.current = action;
  const enabled = action !== null;
  const label = action?.label ?? "";
  useEffect(() => {
    if (!enabled) return set(null);
    set({ label, icon: ref.current!.icon, onClick: () => ref.current?.onClick() });
    return () => set(null);
  }, [set, enabled, label]);
}
